import { timestampToDate } from "@/lib/date-utils";
import type { FirestoreTimestamp } from "@/lib/types";
import { formatDistanceToNow } from "date-fns";
import { useEffect, useState } from "react";

export const useRelativeTime = (value: FirestoreTimestamp | Date | null | undefined): string | null => {
  const [label, setLabel] = useState<string | null>(null);

  useEffect(() => {
    const targetWindow = globalThis.window;
    if (!targetWindow) {
      return;
    }

    const date = timestampToDate(value);
    if (!date) {
       
      setLabel(null);
      return;
    }

    const updateLabel = () => {
      setLabel(formatDistanceToNow(date, { addSuffix: true }));
    };

    updateLabel();
    const intervalId = targetWindow.setInterval(updateLabel, 60_000);

    return () => {
      targetWindow.clearInterval(intervalId);
    };
  }, [value]);

  return label;
};
